// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JJY4X","fullView":"styles_fullView__33wAG"};